// src/components/BrandingBadge.js
import TwineLogo from "../icons/twine.svg";

const BrandingBadge = () => {
  return (
    <div className="branding-badge">
      <a
        href="https://www.twine.net"
        target="_blank"
        rel="noopener noreferrer"
        className="branding-badge-link"
      >
        <span className="branding-badge-text">Powered by</span>
        <img
          src={TwineLogo}
          alt="Twine"
          className="branding-badge-logo"
          width="16"
          height="16"
        />
        <span className="branding-badge-brand">Twine</span>
      </a>
    </div>
  );
};

export default BrandingBadge;
